import $ from 'jquery';

let headerShrink = () => {
  const $header = $('.site-header');
  if (!$header.length) return;

  const toggle = () => {
    $header.toggleClass('scrolled', $(window).scrollTop() > 10);
  };

  toggle();
  $(window).off('scroll.headerShrink').on('scroll.headerShrink', toggle);
};

export default headerShrink;